export enum HoldingMethod {
  DIRECT = 'DIRECT',
  PEA = 'PEA',
  PEA_PME = 'PEA_PME',
}
